












































































import { Component, Vue } from 'vue-property-decorator';
import { LocationDetailsModule } from '@/store/modules/locationDetails'
import DepartmentDto from '@/models/Departments/DepartmentDto';
// import ContactEdit from '@/components/Contacts/ContactEdit.vue';
import LocationDepartmentCreate from '@/components/Locations/LocationDepartmentCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'LocationDepartmentsMasterDetails',
  components: { LocationDepartmentCreate }
})
export default class extends GiganautVue {

    async created() {
        await  LocationDetailsModule.getDepartments();
    }

    async updateCurrentDepartment(department: DepartmentDto) {
        await LocationDetailsModule.updateCurrentDepartment(department);
    }

    get currentDepartment() {
        return LocationDetailsModule.currentDepartment;
    }

    get loadingDepartments() {
        return LocationDetailsModule.loadingDepartments;
    }

    get departments() {
        return LocationDetailsModule.departments;
    }
}
